/**
 * API Management Service Client (หน้าบ้าน)
 * หน้าที่การทำงานหลัก:
 * - ตัวเชื่อมต่อเครือข่าย (HTTP Client) สำหรับการส่ง Request ไปหา Backend API endpoints ของ API Management
 * - เรียกใช้ผ่าน axios instance (`client`) เพื่อแนบ Token ยืนยันตัวตนอัตโนมัติ
 * 
 * ส่วนที่มีการแก้ไขเพิ่มเติม:
 * - เพิ่มฟังก์ชัน `getTpApiSchTransactions` สำหรับยิง Request ไปดึงรายการประวัติของ API Scheduler จาก Backend endpoint `/api-management/getTpApiSchTransactions`
 */

import client from './instance'
import { createBy, updateBy } from 'utils/apiHelper'

export const getApiManagements = async (data) => {
  try {
    const response = await client.post('/api-management/getApiManagements', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getApiManagementById = async (data) => {
  try {
    const response = await client.post('/api-management/getApiManagementById', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const createApiManagement = async (data) => {
  try {
    const response = await client.post('/api-management/createApiManagement', createBy(data))
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const updateApiManagement = async (data) => {
  try {
    const response = await client.post('/api-management/updateApiManagement', updateBy(data))
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const activeApiManagements = async (data) => {
  try {
    const response = await client.post('/api-management/activeApiManagements', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const inActiveApiManagements = async (data) => {
  try {
    const response = await client.post('/api-management/inActiveApiManagements', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getTpApiSchTransactions = async (data) => {
  try {
    const response = await client.post('/api-management/getTpApiSchTransactions', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getTpApiSchTransactionsDtl = async (data) => {
  try {
    const response = await client.post('/api-management/getTpApiSchTransactionsDtl', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const exportTpApiSchTransactions = async (data) => {
  try {
    const response = await client.post('/api-management/exportTpApiSchTransactions', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

// Detailed Result View (api) : ดึงข้อมูล Schedule Result ตาม API Management ID จากระบบ
export const getScheduleResult = async (data) => {

  try {
    const response = await client.post('/api-management/getScheduleResult', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

